import { useTranslation } from "react-i18next";

type MovementTextProps = {
  movement: number;
};

export function MovementText({ movement }: MovementTextProps) {
  const { t } = useTranslation();

  if (movement > 30) {
    return t("High");
  }

  if (movement > 10) {
    return t("Medium");
  }

  if (movement > 2) {
    return t("Light");
  }

  return t("calm");
}
